import React, { useRef, useEffect } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';

const SaveAgendaModal = ({
  show,
  onHide,
  codAgenda,
  nomePac,
  onConfirm,
  criticalAlerts = [],
}) => {
  const confirmBtnRef = useRef(null);
  const hasBlockingAlert = criticalAlerts.some(alert => alert.bloqueia);

  useEffect(() => {
    if (show && confirmBtnRef.current) {
      confirmBtnRef.current.focus();
    }
  }, [show, criticalAlerts]);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className="font-weight-bold">
        {criticalAlerts.length > 0
          ? 'Atenção!'
          : 'Confirma gravação da agenda?'}
      </Modal.Header>
      <Modal.Body>
        {criticalAlerts.length > 0 && (
          <div style={{ marginBottom: 16 }}>
            {criticalAlerts.map((alert, idx) => (
              <Alert
                key={idx}
                variant={
                  alert.tipo === 'danger' || alert.tipo === 'error'
                    ? 'danger'
                    : 'warning'
                }
              >
                {alert.msg}
              </Alert>
            ))}
          </div>
        )}
        Agendamento: <strong>{codAgenda ? ` ${codAgenda}` : ''}</strong>
        <br />
        Paciente: <strong>{nomePac}</strong>
        <br />
      </Modal.Body>
      <Modal.Footer>
        {hasBlockingAlert ? (
          <Button variant="secondary" onClick={onHide} ref={confirmBtnRef}>
            Fechar
          </Button>
        ) : (
          <Button
            variant={criticalAlerts.length > 0 ? 'primary' : 'success'}
            onClick={onConfirm}
            ref={confirmBtnRef}
          >
            {criticalAlerts.length > 0 ? 'Confirmar e Gravar' : 'Confirmar'}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default SaveAgendaModal;
